import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.473 6.133A4.667 4.667 0 0 0 3.566 7.4a2.667 2.667 0 0 0 .627 5.26h7.334a3.334 3.334 0 0 0 .946-6.527m-.947 5.193H4.194a1.333 1.333 0 1 1 0-2.666.667.667 0 0 0 .667-.667 3.333 3.333 0 0 1 6.487-1.073.67.67 0 0 0 .52.44 2 2 0 0 1-.34 3.966"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })